import orderBy from 'lodash/orderBy'

import { IDate } from '@avantstay/arriere-clients/dist/arriereBackoffice'

export function sortServiceRequestsByCreationDate<T extends { createdAt: IDate }>(
  serviceRequests: T[],
): T[] {
  return orderBy([...serviceRequests], ['createdAt'], ['desc'])
}
